module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/locale.zh-cn.js
 ** module id = 13
 ** module chunks = 0
 **/